// extracted by mini-css-extract-plugin
export default {"popupCopied":"SetupV1_popupCopied__gSaIC"};